import { defineStore } from 'pinia';

import * as state from './ui.state';
import * as getters from './ui.getters';
import * as actions from './ui.actions';

export const useUiStore = defineStore('ui', () => ({
  ...state,
  ...getters,
  ...actions
}));
